import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {INotification, INotificationPayload} from "../../models/notification"

interface INotificationState {
  isLoading: boolean
  countNew: number
  countReaded: number
  list: INotification[]
}

const initialState: INotificationState = {
  isLoading: false,
  countNew: 0,
  countReaded: 0,
  list: [],
}

export const notificationSlice = createSlice({
  initialState,
  name: "notification",
  reducers: {
    fetching(state) {
      state.isLoading = true
    },
    fetchSuccess(state, action: PayloadAction<INotificationPayload>) {
      state.isLoading = false
      state.countNew = action.payload.countNew
      state.countReaded = action.payload.countReaded
      state.list = action.payload.list
    }
  }
})

export default notificationSlice.reducer